<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { Table } from "../../components/Table";
  import Input from "../../components/Form/Fields/Input.svelte";
  import { initList, loading, records, record, save, onDelete, onEdit, onCreate } from "./customer-cod317.store";
  import { customerCod317Fields } from "../../utils/TableFields/customer-cod317.fields";
  import { isUserRoleADM } from "../../app.store";

  export let customerId: number;

  $: isNew = $record != null && $record.oid == 0;
  $: canSubmit = $record != null && !!$record.cod317;

  async function onSubmit() {
    await save();
    initList(customerId);
  }

  function onCancel() {
    initList(customerId);
  }

  onMount(() => initList(customerId));
</script>

{#if !!customerId}
  {#if !!$record}
    <div class="columns" style="height: unset;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-6">
              <FormField>
                <Input name="Codice 317" placeholder="codice 317" required={true} bind:value={$record.cod317} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}

  <Table
    loading={$loading}
    fields={customerCod317Fields}
    records={$records}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={$isUserRoleADM}
    on:create={(e) => onCreate(customerId)}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
  />
{/if}
